import { CheckoutPlan } from "@generated"
import { getGraphqlClient } from "@lib/graphql-client"
import { useCurrency } from "@lib/hooks/use-currency"
import { useMutation } from "@tanstack/react-query"

const { sdk } = getGraphqlClient()
const planMap = {
  Basic: CheckoutPlan.BasicPlan_2023V1,
  Business: CheckoutPlan.BusinessPlan_2022V1,
}
export function useCreateCheckoutSessionMutation() {
  const { currency } = useCurrency()
  return useMutation({
    mutationFn: async (planName: string) => {
      const plan = planMap[planName]
      if (!plan) {
        throw new Error("Unknown plan " + planName)
      }
      return await sdk.CreateCheckoutSession({
        input: {
          currency,
          cancelUrl: `${window.location.origin}/signup/success?subscription=error`,
          successUrl: `${
            window.location.origin
          }/signup/success?subscription=success&subscribed_plan=${planName}&purchase_time=${new Date().toISOString()}`,
          plan,
          downgradeReason: null,
        },
      })
    },
  })
}
